import styled from 'styled-components'

// Settings section styled components
export const SettingsSection = styled.div`
  margin-top: var(--space-400);
  height: 320px;
  overflow-y: auto;
`

export const SettingsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-400);
`

export const SettingsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`

export const SortableSettingItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-200);
`

export const SettingItem = styled.div`
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  padding: var(--space-400);
  background-color: var(--bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
`

export const SettingInfo = styled.div`
  flex: 1;
`

export const SettingName = styled.div`
  font-weight: var(--font-weight-semibold);
  margin-bottom: var(--space-100);
  color: var(--text-primary);
`

export const SettingType = styled.div`
  color: var(--text-secondary);
  font-size: var(--font-size-200);
  text-transform: uppercase;
  margin-bottom: var(--space-100);
`

export const SettingDefault = styled.div`
  color: var(--text-secondary);
  font-size: var(--font-size-300);
`

export const SettingActions = styled.div`
  display: flex;
  gap: var(--space-200);
`

export const EmptySettings = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  text-align: center;
  padding: var(--space-800) var(--space-400);
  color: var(--text-secondary);
`

export const EmptySettingsText = styled.div`
  font-size: var(--font-size-400);
  margin-bottom: var(--space-100);
`

export const EmptySettingsSubtext = styled.div`
  font-size: var(--font-size-300);
  color: var(--icon-secondary);
`

export const SettingsModalContent = styled.div`
  padding: var(--space-400) 0;
`

export const InlineEditorContainer = styled.div`
  padding: var(--space-300) 0;
`

export const AddButtonContainer = styled.div`
  padding: var(--space-400);
`
